const POST_GOOGLE_LOGIN_REQUESTED = "POST_GOOGLE_LOGIN_REQUESTED";
const POST_GOOGLE_LOGIN_SUCCEEDED = "POST_GOOGLE_LOGIN_SUCCEEDED";
const POST_GOOGLE_LOGIN_FAILED = "POST_GOOGLE_LOGIN_FAILED";

export {
  POST_GOOGLE_LOGIN_REQUESTED,
  POST_GOOGLE_LOGIN_SUCCEEDED,
  POST_GOOGLE_LOGIN_FAILED,
}
